<template lang="pug">
v-card.mb-3
  v-card-title.grey.lighten-4
    a.title(v-if="extra.options && extra.options.title_url" :href="extra.options.title_url") {{extra.name}}
    .title(v-else) {{extra.name}}
    v-spacer
    v-btn.inline-btn(icon @click="reload" :loading="$apollo.queries.extras.loading"): v-icon loop
  v-tabs(v-model="active")
      v-tab {{content.name}}
      v-tab-item: v-card(flat)
        v-card-text
          router-link.mb-2.subheading(:to="contentUrl(content.content)") {{content.content.title}}
          div(v-html="content.content.preamble")

</template>

<style lang="stylus" scoped>
.inline-btn
  margin -8px -4px -8px 0
</style>

<script>
import ContentUrl from '../../mixins/content-url'
import gql from 'graphql-tag'

export default {
  props: ['extra'],
  mixins: [ContentUrl],
  data() {
    return {
      active: null,
      skipLoad: true,
      extras: [],
    }
  },
  apollo: {
    extras: {
      query: gql`query ($id: ID!) {
        extras(where: { id: $id }) {
          id
          content
        }
      }`,
      variables() {
        return { id: this.extra.id }
      },
      skip() {
        return this.skipLoad || !this.extra || !this.extra.id
      }
    }
  },
  computed: {
    content() {
      let extra = this.extras.length ? this.extras[0] : this.extra
      return JSON.parse(extra && extra.content || null) || {}
    }
  },
  methods: {
    reload() {
      if (this.skipLoad) {
        this.skipLoad = false
      } else {
        this.$apollo.queries.extras.refetch()
      }
    }
  }
}
</script>
